import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { MODULES } from '../../features/moduleRegistry';
import { getModuleStatus, hasUsedTrial } from '../../features/moduleAccess';
import '../features/moduleLicense.css';
import '../admin/admin.css';

// Routen-Gate pro Modul (für die bisher nur login-gated Work-Bereiche).
// Ohne Modul erscheint keine 404, sondern eine freundliche Hinweisseite;
// für ehemals aktive Module die Pause-Seite (Daten bleiben erhalten).
export default function ModuleRoute({ moduleKey, children }) {
  const { user, loading, hasModule, licenseData, enabledFeatures, userSettings } = useAuth();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (hasModule(moduleKey)) {
    return children;
  }

  const mod      = MODULES[moduleKey];
  const userData = { ...licenseData, enabledFeatures, userSettings };
  const info     = getModuleStatus(userData, moduleKey);
  const isPaused = info.status === 'paused';

  return (
    <div className="mlz-gate">
      <div className="mlz-gate__card">
        <span className="mlz-gate__icon" aria-hidden="true">{mod?.icon || '🧩'}</span>
        <h2 className="mlz-gate__title">{mod?.name || 'Modul'}</h2>
        {isPaused ? (
          <>
            <span className="mlz-badge mlz-badge--paused">Pausiert</span>
            <p className="mlz-gate__text">
              Dieses Modul ist pausiert. Deine Daten und dein Stand bleiben erhalten —
              du machst genau hier weiter, sobald du es wieder aktivierst.
            </p>
          </>
        ) : (
          <>
            <p className="mlz-gate__text">{mod?.description}</p>
            <p className="mlz-gate__text">
              Dieser Bereich gehört zum Modul „{mod?.name}", das in deinem Zugang noch
              nicht enthalten ist.
              {mod && !hasUsedTrial(userData, moduleKey) && mod.status === 'available' &&
                ' Du kannst es 2 Wochen kostenlos testen.'}
            </p>
          </>
        )}
        <Link to="/settings" className="mlz-btn mlz-gate__cta">
          {isPaused ? 'Wieder aktivieren' : 'Zu Module & Lizenz'}
        </Link>
      </div>
    </div>
  );
}
